const config = {
    "Group": {
        "EAP1": 360,
        "EAP2": 328,
        "EAP3": 431,
        "TopUpPercent1": 0.099403,
        "TopUpPercent2": 0.099403,
        "TopUpPercent3": 0.099403
    }
}

export default config;